import styled from '@emotion/styled';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  overflow: hidden;
`;

export const Container = styled.div`
  width: 100%;
  height: 0.25em;
  position: relative;
  border-radius: 50%;
`;

const barHeight = 0.25;

interface HandleProps {
  color: string;
  handleSize: number;
  left: number;
  barWidth: number;
}
export const Handle = styled.div<HandleProps>`
  position: absolute;
  height: ${({handleSize}) => handleSize}px;
  width: ${({handleSize}) => handleSize}px;
  border-radius: 50%;
  margin-top: -${({handleSize}) => handleSize / 2}px;
  top: 50%;
  background-color: ${({color}) => color};
  transform: translate(${({left}) => left}px, 0);

  &:focus-visible {
    outline: none;
    border: 1px solid #63b3ed;
    box-shadow: inset 0 0 0 1px #63b3ed, 0 0 3px 1px #63b3ed;
  }

  &:before,
  &:after {
    content: '';
    position: absolute;
    display: block;
    top: 50%;
    height: ${barHeight}em;
    margin-top: -${barHeight / 2}em;
    width: ${({barWidth}) => barWidth}px;
  }

  &:before {
    background-color: ${({color = 'red'}) => color};
    left: -${({barWidth, handleSize}) => barWidth - handleSize / 2}px;
  }

  &:after {
    left: ${({handleSize}) => handleSize}px;
    background: rgba(255, 255, 255, 0.2);
  }
`;
